<script>
import {money} from "../../../../core/forms/money";
import Form from "../../../../core/forms/form";
import FileUpload from "../../components/FileUpload.vue";

export default {
    name: "CorporateTransactionInitForm",
    mixins: [money],
    components: {
        PhoneInput: () => import('../../../../components/custom/phone-input.vue'),
        FileUpload
    },
    data: function () {
        return {
            message : '',
            user: window.user,
            loading: false,
            currency: '',
            methods: {
                'ecocash': 'ZWG',
                'stripe': 'USD',
                'ecocash-usd': 'USD',
                'bank-usd': 'USD',
                'bank': 'ZWG',
                'cash': 'USD',
            },
            wallets : [],
            form: new Form({
                name: '',
                payment: '',
                email: window.user.email,
                amount: '',
                ecocash: '',
                wallet: '',
                pop: '',
            })
        };
    },
    methods: {
        fileChange: function (field) {
            this.form[field] = this.$refs[field].files[0];
        },
        submit: function () {

            if (localStorage.getItem('loadedOnce') === "true") {
                localStorage.setItem('loadedOnce', false);
            }
            this.loading = true;
            this.form.upload('/business/wallets/deposit/api').then((response) => {

                if (response.data.success) {
                    //this.$route.query.id
                    //this.$route.params.id
                    if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd")
                    {
                        this.$router.push(`/business/wallets/deposit/ecocash?id=${response.data.body.payment.ref}`);
                    }

                    if (response.data.body.payment.payment === "stripe") {
                        window.location.href = response.data.body.payment.url;
                    }

                    if (response.data.body.payment)
                    {
                       this.$toast.success(response.data.body.payment.message, { timeout: 3000 });
                                setTimeout(() => {
                                    this.$router.push('/business/wallets');
                                }, 3000);
                    }
                }

                }).finally(() => this.loading = false);
        },
        setCurrency: function(currency){
            this.currency = currency;
        },
        fwallets: function () {
            window.axios.get(`/business/wallets/list/all`).then((response) => {
                this.wallets = response.data.body.list;
            });
        },
    },
    watch: {
        'form.wallet': function(newWalletId) {
            const selectedWallet = this.wallets.find(wallet => wallet.id === newWalletId);
            if (selectedWallet) {
                this.setCurrency(selectedWallet.currency);
            }
        }
    },
    mounted() {
        this.fwallets();
    }
}
</script>

<template>

    <div class="col-lg-9">
        <div class="row mb-3">
            <div class="col-lg-7">
                <h2 class="text-7 mb-1">Fund Wallet</h2>
                <p class="text-2 mb-4 text-left">
                    Fund your wallets recharge multiple accounts in one go!
                </p>
            </div>
            <div  class="col-lg-5">
                <div class="row d-flex flex-row-reverse">
                    <div v-for="i in wallets"  v-if="i.type === 'Corporate'" :key="i.id" class="col-6">
                        <div
                            :class="{'account-card-primary':  i.status === 'ACTIVE'}"
                            class="d-block account-card text-white rounded p-2 mb-4 mb-lg-0">
                            <small class="text-uppercase font-weight-700">{{ i.type }}</small>

                            <p class="d-flex align-items-center m-0">
                            <span class="text-uppercase font-weight-500 text-4">
                                {{money(i.balance) }}
                            </span>
                            </p>
                            <p class="text-1 text-uppercase m-0">
                                {{ i.currency }} Wallet
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-12">
                <!-- Payment Methods Information -->
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="card-title mb-2">Payment Methods</h5>

                        <hr>
                        <!-- Other Payment Methods -->
                        <div class="py-3">
                            <h6 class="">Instant Funding</h6>
                            <p class="text-muted small mb-3">Process your payment instantly using any of these methods. Funds will be available in your wallet immediately after successful payment.</p>
                            <div class="row align-items-center">
                                <div class="col-md-12">
                                    <div class="d-flex flex row align-items-center pl-3 py-3">
                                        <img src="/img/payments/visa.png" alt="Visa & Mastercard" class="mr-4" style="height: 25px;">
                                        <img src="/img/payments/mastercard.png" alt="Visa & Mastercard" class="mr-4" style="height: 30px;">
                                        <img src="/img/EcoCash.svg" alt="EcoCash" class="mr-4" style="height: 25px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Bank Transfer Section -->
                        <div class="mb-4">
                            <h6 class="">Bank Transfer</h6>
                            <p class="text-muted small mb-0">Make a direct bank transfer to our accounts. Please ensure to upload your proof of payment (POP) after making the transfer. Funds will be credited to your wallet once the transfer is verified.</p>
                            <div class="row ">
                                <div class="col-md-6">
                                    <div class="alert alert-info">
                                        <p class="mb-2 border-bottom pb-2 text-1">For Airtime and Other Purchases:</p>
                                        <ul class="list-unstyled mb-0">
                                            <li><strong>Company Name:</strong> Qwiktech Solutions Private Limited</li>
                                            <li><strong>Bank:</strong> Stanbic Bank Zimbabwe</li>
                                            <li><strong>Branch:</strong> Belgravia</li>
                                            <li><strong>USD Account:</strong> 9140009152090</li>
                                            <li><strong>ZWG Account:</strong> 9140009152007</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="alert alert-info">
                                        <p class="mb-2 border-bottom pb-2 text-1">For ZESA Token Purchases:</p>
                                        <ul class="list-unstyled mb-0">
                                            <li><strong>Company Name:</strong> Qwiktech Solutions Private Limited</li>
                                            <li><strong>Bank:</strong> ZB Bank Zimbabwe</li>
                                            <li><strong>Branch:</strong> Borrowdale</li>
                                            <li><strong>USD Account:</strong> 412900158986405</li>
                                            <li><strong>ZWG Account:</strong> 412900158986080</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <!-- Existing Deposit Form Card -->
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title mb-2">Wallet Funding</h5>

                        <hr>
                        <div :class="['dimmer' , loading ? 'active' : '']">
                            <div class="loader"></div>
                            <div class="dimmer-content">
                                <div class="text-left">
                                    <div class="">
                                        <div  v-if="message && message !== ''" class="bg-primary text-center text-white p-2 mb-3">
                                            {{ message }}
                                        </div>

                                        <div class="form-group">
                                            <label> Wallet </label>
                                            <select required v-model="form.wallet" :class="[ 'custom-select' , form.errors.get('wallet') ? 'is-invalid' : '' ]">
                                                <option value="">Choose Wallet</option>
                                                <option v-for="i in wallets" v-if="i.type === 'Corporate'" :value="i.id">{{ i.type.toUpperCase() }} - {{ i.currency }} - {{ i.status }} - {{ money(i.balance)}}</option>
                                            </select>
                                            <div v-text="form.errors.get('wallet')" class="invalid-feedback"/>
                                        </div>

                                        <div class="form-group" v-if="form.wallet">
                                            <label> Pay with </label>
                                            <select required v-model="form.payment" :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                                                <option value="">Choose Payment Method</option>
                                                <option v-if="currency === 'ZWG' " value="ecocash">EcoCash ZWG</option>
                                                <option v-if="currency === 'USD'" value="ecocash-usd">EcoCash USD</option>
                                                <option v-if="currency === 'USD'" value="stripe">International Card USD</option>
                                                <option v-if="currency === 'ZWG' || currency === 'USD'" value="bank">Bank Transfer</option>
                                            </select>
                                            <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                                        </div>
                                        <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd'" class="form-group">
                                            <label>EcoCash Phone Number</label>
                                            <phone-input v-model="form.ecocash" required
                                                         :class="[ form.errors.get('ecocash') ? 'is-invalid' : '', form.errors.get('ecocash-usd') ? 'is-invalid' : '']"
                                                         placeholder="EcoCash Phone Number"/>
                                        </div>
                                        <div v-else class="form-group">
                                            <label>Email</label>
                                            <input type="email" v-model="form.email" value="email"
                                                   required
                                                   :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                                                   placeholder="Email">
                                            <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                        </div>

                                        <div class="form-group">
                                            <label>Amount</label>
                                            <input type="number" v-model="form.amount" value="amount"
                                                   required
                                                   :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                                                   placeholder="Amount">
                                            <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                                        </div>

                                        <div class="form-group" v-if="form.payment === 'bank'">
                                            <label>POP</label>
                                            <FileUpload
                                                :hide-save="true"
                                                fileType="pdf"
                                                v-model="form.pop"
                                            />
                                            <div v-text="form.errors.get('pop')" class="invalid-feedback"/>
                                        </div>

                                        <button @click="submit" :class="{'btn-loading': loading}" class="btn btn-success btn-block shadow-none mt-3 mb-2">
                                            <i class="fa fa-check"></i> Submit Transaction
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
